import {
  ESCALATIONTYPES_REQUEST, ESCALATIONTYPES_SUCCESS, ESCALATIONTYPES_FAILURE,
  LOCATION_ISSUETYPES_REQUEST, LOCATION_ISSUETYPES_SUCCESS, LOCATION_ISSUETYPES_FAILURE
} from "./EscalationTypesActions";

const initialState = {
  data: null,
  error: null,
  isLoading: false
}

export default function escalationTypesReducer(state = initialState, { type, payload } ){
  switch (type) {
    case ESCALATIONTYPES_REQUEST:
      return { ...state, isLoading: true }
    case ESCALATIONTYPES_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case ESCALATIONTYPES_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    case LOCATION_ISSUETYPES_REQUEST:
      return { ...state, isLoading: true }
    case LOCATION_ISSUETYPES_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false }
    case LOCATION_ISSUETYPES_FAILURE:
      return { ...state, error: payload.error, isLoading: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/escalation-types/EscalationTypesReducer.js